import { data } from "autoprefixer";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Form } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { actionCreators } from "../../state/index";
import UllasAPI from "../../utils/api/UllasAPI";
import { UllasContext } from "../../state/context/UllasProvider";
import { Button, Pagination } from "antd";
import { serverAddress } from "../../constant";
import { notify_error } from "../Notify";
import TableSkeleton from "../skeletons/TableSkeleton";


const AnveshanTable = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { top_loader } = bindActionCreators(actionCreators, dispatch);
  const [data, setData] = React.useState([]); // Corrected state name from setDate to setData
  const [loading, setLoading] = useState(false);
  const [totalData, setTotalData] = useState(0);
  const [recperpage, SetRecPerPage] = useState(25);
  const [activepage, SetActivePage] = useState(1);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedEvents, setSelectedEvents] = useState([]);

  const handleRowClick = (student) => {
    setSelectedEvents(student.events || []); // Set the events array
    setIsModalVisible(true);
  };

  const handleClose = () => {
    setIsModalVisible(false);
  };
  // console.log("---24---",totalData);
  //   const {
  //     filter,
  //     setFilter,
  //     search,
  //     SetSearch,
  //     recperpage,
  //     SetRecPerPage,
  //     activepage,
  //     SetActivePage,
  //     totalData,
  //     setTotalData,
  //  } = React.useContext( UllasContext);

  useEffect(() => {
    top_loader(true, 45);
    getAllUllas({ page: activepage, limit: recperpage });
    // eslint-disable-next-line
  }, []);
  useEffect(() => {
    // Dynamically inject CSS for scrollbar hiding, only for the sidebar
    const styleElement = document.createElement("style");
    styleElement.innerHTML = `
      .custom-sidebar::-webkit-scrollbar { display: none; }  /* For Chrome, Safari */
      .custom-sidebar { -ms-overflow-style: none; scrollbar-width: none; }  /* For IE, Firefox */
    `;
    document.head.appendChild(styleElement);

    // Clean up the style when the component is unmounted
    return () => {
      document.head.removeChild(styleElement);
    };
  }, []);

  const getAllUllas = async(params) => {
    setLoading(true);
   // UllasAPI.getAllUllas(params).then((result) => {
    const response = await fetch(`${serverAddress}/llm_crashcourse/get-all?page=${params?.page}&limit=${params?.limit}`);
    const result = await response.json();
     // if (result.status) {
         console.log("---48---",result);
        setData(result.alumnis) // Corrected state update from setDate to setData
        setTotalData(result.totaldata);
        // console.log("---51---",result.data.total);
        setLoading(false);
        top_loader(true, 100);
        top_loader(false, 0);
    //  }
    //    else {
    //     setData([]); // Corrected state update from setDate to setData
    //     setLoading(false);
    //     top_loader(true, 100);
    //     top_loader(false, 0);
    //   }
    //});
  };
  useEffect(() => { 
    console.log("Data", data);
  }, [data]);

  function handlePageChange(page) {
    SetActivePage(page);
    getAllUllas({ page: page, limit: recperpage });
  }

  function applyFilter(event) {
    SetRecPerPage(event.target.value);
    getAllUllas({ page: 1, limit: event.target.value });
    SetActivePage(1);
  }

  async function handleDownloadButtonClick() {
    try {
      const url = new URL(`${serverAddress}/llm_crashcourse/download`);
      // url.searchParams.append("search", search || "");
      // url.searchParams.append("page", activepage);
      // url.searchParams.append("limit", recperpage);
  
      const res = await fetch(url);
      const response = await res.json();

  
       const results = response?.alumnis;

       console.log(results);
  
      if (!results || !Array.isArray(results) || results.length === 0) {
        notify_error("No data found to download.");
        return;
      }
  
      const csvContent = convertJsonToCsv(results);
      const blob = new Blob([csvContent], { type: "text/csv" });
  
      const a = document.createElement("a");
      a.style.display = "none";
      a.href = URL.createObjectURL(blob);
      a.download = "llm_crash_course_students.csv";
  
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (error) {
      notify_error("Error fetching or downloading data:", error);
    }
  }
  
  function convertJsonToCsv(data) {
    const headers = Object.keys(data[0]);
    const rows = data.map((row) =>
      headers.map((field) => `"${(row[field] ?? "").toString().replace(/"/g, '""')}"`).join(",")
    );
    return [headers.join(","), ...rows].join("\n");
  }

  // console.log(data)
  return (
    <Container
      fluid
      className="p-0 custom-sidebar"
      style={{
        backgroundColor: "#F2F5F7",
        fontFamily: "Inter",
        height: "100vh",
        overflowY: "auto",
      }}
    >
      <Row style={{ marginInline: "10px" }}>
        <Col lg={12}>
        <div
              lg={12}
              className="bg-white mx-0 rounded"
              style={{
                display: "flex",
                justifyContent: "end",
                marginTop: "5rem",
              }}
            >
              

              <div className="d-flex flex-column flex-sm-row justify-content-between align-items-center">
                {/* Button Group */}
                <div className="d-flex align-items-center mx-1 mt-2 p-2 mt-sm-0">
                  {/* Export/download */}
                  <div className="mx-2" style={{ padding: "4px", margin: "0" }}>
                    <Button
                      onClick={() => handleDownloadButtonClick()}
                      style={{
                        backgroundColor: "#663399",
                        color: "#fff",
                        borderColor: "#663399",
                        width: "auto",
                        padding: "8px 12px", // Reduced padding for smaller buttons
                        height: "38px", // Slightly reduced height
                        whiteSpace: "nowrap",
                        borderRadius: "8px",
                        transition: "none", 
                        marginTop:"2px",
                        marginBottom:"2px",
                      }}
                    >
                      <i style={{color:"white"}} className="fa-solid fa-download me-2"></i>Export
                    </Button>
                  </div>

                  {/* Refresh Icon */}
                 
                </div>
              </div>
            </div>
          <div className="py-2" >
            <div
              className="maintable"
              id="table-container"
              style={{ height: "auto", width: "auto" }}
            >
              {loading ? (
                <TableSkeleton />
              ) : (
                <table className="col-md-12 enquiryTable px-3">
                <thead className="bg-transparent ">
                  <tr className="tableHeading tableHeadAllEnquiry bg-transparent"  
                  // onClick={() =>
                  //               navigate(`/dashboard/llm-crashcourse-registration/${item._id}`)
                  //             }
                              >
                    <th>S.No.</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Mobile</th>
                    {/* <th>Program</th>
                    <th>Institute Name</th>
                    <th style={{ width: "10%" }}>Payment Status</th> */}
                    
                  </tr>
                </thead>

                <tbody>
                  {data.length > 0 ? (
                    data.map((item, index) => (
                      <tr
                        key={item._id} // Added unique key for each row
                        className="tableRows"
                        onClick={() =>
                            navigate(`/dashboard/llm-crashcourse-registration/${item._id}`)
                          }
                      >
                        <td>{(activepage - 1) * recperpage + index + 1}</td>
                        <td style={{ width: "15%" }}>{item.fullName}</td>
                        <td style={{ width: "15%" }}>{item.email}</td>
                        <td>{item.phone}</td>
                        {/* <td>{item.course}</td>
                        <td>{item.institute}</td>
                        <td>
                          {item.paymentStatus === "Not Paid" && (
                            <span
                              style={{
                                border: "1px solid #FFE3E0",
                                backgroundColor: "#FFE3E0",
                                color: "#F7685B",
                                padding: "3px 13px",
                                borderRadius: "4px",
                              }}
                            >
                              Not Paid
                            </span>
                          )}
                          {item.paymentStatus === "Payment Unsuccessfull" && (
                            <span
                              style={{
                                border: "1px solid #FFE3E0",
                                backgroundColor: "#FFE3E0",
                                color: "#F7685B",
                                padding: "3px 13px",
                                borderRadius: "4px",
                              }}
                            >
                              Not Paid
                            </span>
                          )}
                          {item.paymentStatus === "Paid" && (
                            <span
                              style={{
                                border: "1px solid #CAEEDB",
                                backgroundColor: "#CAEEDB",
                                color: "#46CF85",
                                padding: "3px 5px",
                                borderRadius: "4px",
                              }}
                            >
                              Payment Done
                            </span>
                          )}
                        </td> */}
                        
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="8" style={{ textAlign: "center" }}>
                        No data available
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
              )}
            </div>

            {/* <div className="tableEnd"></div> */}
            <div className="col-md-12 form-inline py-2 tableFooter d-flex gap-5 align-items-center">
              <div className="col-md-4 d-flex gap-2 align-baseline">
                <label
                  className="control-label col-md-4"
                  style={{
                    fontWeight: "700",
                    paddingTop: "5px",
                    paddingLeft: "25px",
                  }}
                >
                  Rows per page :
                </label>
                {/* <i className="pi pi-chevron-down" style={{position:"absolute" , left:"92%", top:"15%"}}/> */}
                <Form.Select
                  className="form-control "
                  //onChange={(event) => SetRecPerPage(event.target.value)}
                   onChange={(event) => applyFilter(event)}
                  value={recperpage}
                  style={{
                    border: "solid",
                    borderWidth: "thin",
                    color: "#000",
                  }}
                >
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="75">75</option>
                  <option value="100">100</option>
                  <option value="200">200</option>
                </Form.Select>
              </div>

              <div
                className="col-md-8 d-flex gap-2"
                style={{
                  justifyContent: "end",
                  alignItems: "center",
                  paddingRight: "60px",
                }}
              >
                <Pagination
                  total={totalData}
                  showSizeChanger={false}
                  current={activepage}
                  size="small"
                  // showQuickJumper
                  pageSize={recperpage}
                  onChange={(page, pageSize) => {
                    //SetActivePage(page);
                    handlePageChange(page);
                  }}
                />
              </div>
            </div>
          </div>
        </Col>
      </Row>
   
    </Container>
  );
};

export default AnveshanTable;
